import { Client, PageCollection } from '@microsoft/microsoft-graph-client'
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser'
import { User } from 'microsoft-graph'

let graphClient: Client | undefined

function ensureClient(authProvider: AuthCodeMSALBrowserAuthenticationProvider) {
    if (!graphClient) {
        graphClient = Client.initWithMiddleware({ authProvider })
    }

    return graphClient
}

export async function getUser(
    authProvider: AuthCodeMSALBrowserAuthenticationProvider,
): Promise<User> {
    return ensureClient(authProvider)
        .api('/me')
        .select('displayName,mail,userPrincipalName')
        .get()
}

export async function getUserDetails(
    authProvider: AuthCodeMSALBrowserAuthenticationProvider,
    query: string,
    select: string[],
): Promise<User[]> {
    try {
        const selector = select.join(',')
        const normalizedQuery = query.replace(/[,#]/g, '+')
        const response: PageCollection = await ensureClient(authProvider)
            .api('/me/people')
            .select(selector)
            .search(`"${normalizedQuery}"`)
            .filter(
                `personType/subclass eq 'OrganizationUser' and givenName ne null`,
            )
            .top(10)
            .get()

        return response.value
    } catch (error) {
        console.log('GRAPH API ERR:', error)
        return []
    }
}
